// extracted by mini-css-extract-plugin
export default {"Card":"CreateBoardPage_Card__QnMrl"};